import { API_URL } from '../../env';

import {
    axiosWithAuth,
 } from '../../utils/axiosWithAuth';

import {
    FETCH_ADMIN_USERS_REQUEST,
    FETCH_ADMIN_USERS_SUCCESS,
    FETCH_ADMIN_USERS_FAILURE,
    ADD_ADMIN_USER_REQUEST,
    ADD_ADMIN_USER_SUCCESS,
    ADD_ADMIN_USER_FAILURE,
    DELETE_ADMIN_USER_REQUEST,
    DELETE_ADMIN_USER_SUCCESS,
    DELETE_ADMIN_USER_FAILURE,
    CLEAR_ADMIN_USER_ERROR
} from './actionTypes';

const baseUri = `${API_URL}/api/v1`;

export const getAdminUsers = () => async (dispatch, getState) => {
    const { adminUsers, isLoading } = getState().adminUsers;
    if (adminUsers.length || isLoading) {
        return false;
    }
    const uri = `${baseUri}/admin/users/admin`;
    dispatch({ type: FETCH_ADMIN_USERS_REQUEST });
    try {
        const response = await axiosWithAuth().get(uri);
        dispatch({ type: FETCH_ADMIN_USERS_SUCCESS, payload: response.data });
    } catch (err) {
        dispatch({ type: FETCH_ADMIN_USERS_FAILURE, payload: err.response.data });
    }
}

export const addAdminUser = (email, scope) => async (dispatch) => {
    const uri = `${baseUri}/admin/account/add`;
    dispatch({ type: ADD_ADMIN_USER_REQUEST });
    try {
        const response = await axiosWithAuth().post(uri, { email, scope });
        dispatch({ type: ADD_ADMIN_USER_SUCCESS, payload: response.data });
    } catch (err) {
        dispatch({ type: ADD_ADMIN_USER_FAILURE, payload: err.response.data });
        setTimeout(() => { dispatch({ type: CLEAR_ADMIN_USER_ERROR }) }, 5000);
    }
}

export const deleteAdminUser = (userId) => async (dispatch) => {
    const uri = `${baseUri}/admin/account/user/${userId}`;
    dispatch({ type: DELETE_ADMIN_USER_REQUEST });
    try {
        await axiosWithAuth().delete(uri);
        dispatch({ type: DELETE_ADMIN_USER_SUCCESS, payload: userId });
    } catch (err) {
        dispatch({ type: DELETE_ADMIN_USER_FAILURE, payload: err.response.data });
        setTimeout(() => { dispatch({ type: CLEAR_ADMIN_USER_ERROR }) }, 5000);
    }
}
